let loadingCounter = 0

export default class LoadingManager {

  static show (context, message = null, cancelToken = null) {
    if (loadingCounter <= 0 && context.$root.$children.length > 0) {
      context.$root.$children[0].$emit('loading-show', message, cancelToken)
    }

    loadingCounter++
  }

  static hide (context) {
    if (loadingCounter > 0) {
      loadingCounter--

      if (loadingCounter <= 0 && context.$root.$children.length > 0) {
        context.$root.$children[0].$emit('loading-hide')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/loading.js